import React from "react";

const SelectedOption = ({
  title,
  children,
  linkTo,
  className,
  iconImgSrc,
  icon,
  style,
  childDivClassName,
}) => {
  return (
    <div className={`mb-2 flex ${className} items-start`} style={style}>
      {iconImgSrc ? (
        <img src={iconImgSrc} className="w-[30px] mr-2" alt="" />
      ) : icon ? (
        <span className="w-[30px] mr-2 flex shrink-0 items-center justify-center text-[24px] text-black">
          {icon}
        </span>
      ) : null}
      <a href={linkTo}>
        <h4 className="font-black inline-block mr-2 text-[var(--peachy-pink)]">
          {title}:
        </h4>
      </a>
      <div
        className={`mt-[3px] inline-block ${
          childDivClassName ? childDivClassName : ""
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default SelectedOption;
